// extracted by mini-css-extract-plugin
export default {"linkIcon":"LinkBase_linkIcon__L+DPc"};